import type { Atom } from 'jotai';
import { atom } from 'jotai';

import { processingTypesQueryAtom } from '../_graphql/queryProcessingTypes';
import type { ProcessingTypeRecord } from '../types/processingType';

import type {
  QueryAtomReadValue,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export const $remoteAllProcessingTypes = processingTypesQueryAtom(() => ({
  variables: {
    isActive: true,
    limit: 1000,
    offset: 0,
  },
}));

export const $processingTypesList: Atom<
  Omit<
    QueryAtomReadValue<QueryAtomResult<typeof processingTypesQueryAtom>>,
    'data'
  > & {
    data: ProcessingTypeRecord[];
    isLoading: boolean;
  }
> = atom((get) => {
  const result = get($remoteAllProcessingTypes);
  return {
    ...result,
    data: result.data?.processingTypes ?? [],
    isLoading: result.isPending,
  };
});
